/*eslint-disable*/
import { useGetUnAuthorizedAdmin, usePostUnAuthorizedAdmin } from "./useRequest";

export function loadBasicApplicationConfidentialQuestionnaireAcceptanceStage(jobid) {
  const path = `/quickapplications/${jobid}/confidentialInformationAcceptanceStage`;
  const response = useGetUnAuthorizedAdmin(path);
  return response;
}

export function getBasicJobUrlIdentifier(jobid) {
  const path = `/quickapplications/${jobid}/urlidentifier`;
  const response = useGetUnAuthorizedAdmin(path);
  return response;
}

export function loadJobForBasicApplication(jobid) {
  const path = `/quickapplications/job/${jobid}`;
  const response = useGetUnAuthorizedAdmin(path);
  return response;
}

export function getBasicApplicationByJob(jobid) {
  const path = `/quickapplications/${jobid}/job`;
  const response = useGetUnAuthorizedAdmin(path);
  return response;
}

export function loadBasicApplicationConfidentialQuestionnaire(jobid) {
  const path = `/quickapplications/${jobid}/confidentialquestionnaire`;
  const response = useGetUnAuthorizedAdmin(path);
  return response;
}

export function checkConfidentialQuestionnaireAnswers(jobid, cid) {
  const path = `/quickapplications/job/${jobid}/candidate/${cid}`;
  const response = useGetUnAuthorizedAdmin(path);
  return response;
}

export function loadCandidateProfileData(jobid, code) {
  const path = `/quickapplications/${jobid}/profile?prefillId=${code}`;
  const response = useGetUnAuthorizedAdmin(path);
  return response;
}

export function saveQuickApplyConfidentialQuestionnaireAnswers(jobId, cid, data) {
  const path = `/quickapplications/job/${jobId}/candidate/${cid}/confidentialquestionnaire`;
  const response = usePostUnAuthorizedAdmin(path, data);
  return response;
}

export function addBasicApplication(updateProfile, application, token) {
  const path = `/quickapplications/${updateProfile}?token=${token}`;
  const response = usePostUnAuthorizedAdmin(path, application);
  return response;
}